import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/components/colorPicker/HuePointer.less');

export interface IHuePointerProps
{
    direction?:string;
}

export class HuePointer extends React.Component<IHuePointerProps, any>
{
    public render():JSX.Element
    {
        return (
            <div className={styles.pointer} />
        );
    }
}
